module.exports = __webpack_public_path__ + "static/img/1.5cb0821.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/1.png
// module id = Hefe
// module chunks = 0